<script setup lang="ts">
import { PostFilterBy } from '@/blog/domain/PostFilterBy';
import RadioBlogFilterBy from '@/blog/infrastructure/components/RadioBlogFilterBy.vue';
import SelectBlogCategory from '@/blog/infrastructure/components/SelectBlogCategory.vue';
import SelectBlogFilterBy from '@/blog/infrastructure/components/SelectBlogFilterBy.vue';
import { computed } from 'vue';

interface Emits {
  (e: 'update:category', category: string): void;
  (e: 'update:filterBy', filterBy: PostFilterBy): void;
}

interface Props {
  category: string;
  filterBy: PostFilterBy;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const category = computed({
  get: () => props.category,
  set: value => emit('update:category', value),
});

const filterBy = computed({
  get: () => props.filterBy,
  set: value => emit('update:filterBy', value),
});

</script>

<template>
  <header class="md:w-full md:text-left">
    <div class="gap-4 items-center hidden md:flex">
      <h2 class="text-blue-500 w-fit whitespace-nowrap text-2xl hidden md:inline-block">
        Filter By:
      </h2>
      <SelectBlogCategory v-model:category="category" />
      <SelectBlogFilterBy v-model:filter-by="filterBy" />
    </div>

    <div class="flex items-center gap-6 md:hidden">
      <RadioBlogFilterBy v-model:filter-by="filterBy" />
    </div>
  </header>
</template>
